(() => {
  document.documentElement.addEventListener('wetheme-cart-update', event => {
    const count = event.detail?.cart?.item_count;
    if (typeof count === 'number') document.querySelectorAll('[data-my-cart-count]').forEach(node => { node.textContent = String(count); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.my-header details[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.my-header details[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
})();
